<template>
  <div style="height: 100vh; display: flex; flex-direction: column;">
    <!-- Контейнер карты с динамической высотой -->
    <div
      ref="map-root"
      :style="{ height: showFluoPanel ? '70%' : '100%', width: '100%' }"
    ></div>

    <div v-if="showFluoPanel" class="bottom-panel">
      <!-- Левая фиксированная панель 320px (пустая) -->
      <div class="panel-left-fixed"></div>

      <!-- Контейнер для графика и правой панели (занимает оставшуюся ширину) -->
      <div class="panel-content">
        <div class="panel-chart">
          <VChart
            :option="chartOptions"
            :update-options="{ notMerge: false }"
            autoresize
            style="width: 100%; height: 100%;"
          />
        </div>
        <div class="panel-right">
          <div class="row">
            <p>GPS:{{this.sel_coords[1].toFixed(6)}}, {{this.sel_coords[0].toFixed(6)}}</p>
          </div>
          <div class="row">
            <p>{{this.sel_time}}</p>
          </div>
          <div class="row">
            <p>685 Chlorophyll: 0.23 a.u.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup (оставлен без изменений) -->
    <div ref="popup" class="ol-popup">
      <a ref="popupCloser" class="ol-popup-closer"></a>
      <div ref="popupContent"></div>
    </div>
  </div>
</template>

<script>
import { View, Map, Overlay } from 'ol';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import { Image, Heatmap } from 'ol/layer';
import { Point, LineString } from 'ol/geom';
import { Feature } from 'ol';
import { toLonLat, fromLonLat } from 'ol/proj';
import { unByKey } from 'ol/Observable';
import VectorSource from 'ol/source/Vector';
import XYZ from 'ol/source/XYZ';
import TileWMS from 'ol/source/TileWMS.js';
import {ScaleLine, defaults as defaultControls} from 'ol/control';
// import { Style, Stroke, Fill } from 'ol/style';
// import VectorLayer from 'ol/layer/Vector';
// import WebGLVectorLayer from 'ol/layer/WebGLVector.js';
import ol_source_IDW from '../../source/IDW.js';
import { mapState, mapGetters } from 'vuex';
import 'ol/ol.css';
import { inject, nextTick, ref } from 'vue'
// import GeoJSON from 'ol/format/GeoJSON.js';
// import ChartsView from './ChartsView';
import VectorLayer from 'ol/layer/Vector';
import { Style, Stroke } from 'ol/style';
import VChart from 'vue-echarts';

export default {
  // components: { ChartsView },
  components: { VChart },
  setup() {
    const result = inject('result');
    const idwAction = inject('idwAction');
    const isBathmetry = inject('isBathmetry');
    const isLive = inject('isLive');
    const selected_area = inject('selected_area');
    const redPaletteConfig = inject('redPaletteConfig');
    const greenPaletteConfig = inject('greenPaletteConfig');
    const bluePaletteConfig = inject('bluePaletteConfig');
    const formulae_result1 = inject('formulae_result1');
    const formulae_result2 = inject('formulae_result2');
    const formulae_result3 = inject('formulae_result3');
    const selectedCalRId = inject('selectedCalRId', null);
    const selectedCalGId = inject('selectedCalGId', null);
    const selectedCalBId = inject('selectedCalBId', null);
    const stat = inject('stat');
    const isTrackOn = inject('isTrackOn');
    const isAnimationOn = inject('isAnimationOn');
    let animationFrameId = null;
    // Данные для графика (статические, из условия)
    const wavelengths = [266, 280, 292, 315, 330, 355, 370, 390, 404, 413, 440, 460, 485, 510, 532, 560, 574, 617, 632, 651, 670, 685, 705, 740];
    const intensities = [9, 4, 7, 4, 4.5, 5, 6, 7, 6.5, 6, 5.5, 5, 4.5, 4, 4, 4.5, 5, 4, 4.5, 4, 3, 5, 3, 4];
    const showFluoPanel = ref(false);
    const sel_coords = ref([]);
    const sel_time = ref('');

    return {
      map: null,
      new_view: new View({
        center: fromLonLat([16, 43]),
        zoom: 5,
      }),
      bathmetry_layer: null,
      idwSource: null,
      idw_layer: null,
      heatmap: null,
      isCancelling: false,
      heatmapSource: new VectorSource(),
      redSource: new VectorSource(),
      greenSource: new VectorSource(),
      blueSource: new VectorSource(),
      isClicked: false,
      overlay: null,
      unwatchers: [],
      clickListenerKey: null,
      trackLayer: null,
      result,
      idwAction, 
      isBathmetry,
      isLive,
      selected_area,
      redPaletteConfig,
      greenPaletteConfig,
      bluePaletteConfig,
      formulae_result1,
      formulae_result2,
      formulae_result3,
      selectedCalRId,
      selectedCalGId,
      selectedCalBId,
      stat,
      isTrackOn,
      isAnimationOn,
      animationFrameId,
      sel_coords,
      sel_time,
      // Новые реактивные переменные
      showFluoPanel,
      chartOptions: {
        title: {
          text: 'Fluorescence Spectrum',
          left: 'center',
          textStyle: { fontSize: 12 }
        },
        tooltip: { trigger: 'axis' },
        grid: {
          left: '5%',
          right: '3%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: wavelengths,
          name: 'Wavelength, nm',
          nameLocation: 'middle',
          nameGap: 25
        },
        yAxis: {
          type: 'value',
          name: 'Intensity, a.u.',
          nameLocation: 'middle',
          nameGap: 35
        },
        series: [{
          data: intensities,
          type: 'bar',
          itemStyle: { color: '#5470c6' },
          barWidth: '60%'
        }]
      }
    };
  },
  emits: ['statusDrawing', 'paletteChange'],
  watch: {
    showFluoPanel() {
      nextTick(() => {
        if (this.map) {
          this.map.updateSize();
        }
      });
    },
    idwAction(newV, oldV) {
      if(oldV != newV) {
        if(newV === 'start') {
          this.addIDWLayer(true);
        }
        else if(newV === 'cancel') {
          this.stopIDW().catch(error => {
            console.error('Error stopping IDW:', error);
            // Все равно сбросьте состояния даже при ошибке
            this.$emit('statusDrawing', "taskcancelled", 0);
          });
        }
      }
    },
    isBathmetry(newV, oldV) {
      if(oldV != newV) {
        this.toggleBathmetry(newV);
      }
    },
    selected_area(newV) {
      if(newV) {
        if(newV.poly) {
          // const polygonCoords = newV.poly.coordinates[0].map(coord => fromLonLat(coord));
          // const polygon = new Polygon([polygonCoords]);

          // // const polygonStyle = new Style({
          // //   stroke: new Stroke({
          // //     color: 'rgba(0, 0, 255, 0.7)',
          // //     width: 3
          // //   }),
          // //   fill: new Fill({
          // //     color: 'rgba(0, 0, 255, 0.1)'
          // //   })
          // // });

          // // const polygonLayer = new VectorLayer({
          // //   source: new VectorSource({
          // //     features: [new Feature(polygon)]
          // //   }),
          // //   style: polygonStyle
          // // });

          // // this.map.addLayer(polygonLayer);

          // const view = this.map.getView();
          // view.fit(polygon, {
          //   duration: 1000,
          //   padding: [50, 50, 50, 50],
          //   minResolution: 50
          // });
        }
        else {
          this.map.getView().setZoom(5);
          this.map.getView().animate({
            center: fromLonLat([16, 43]),
            duration: 1000,
            zoom: 5
          });
          // this.map.getView().setZoom(5);
        }
      }
    },
    trackPoints: {
      handler() {
        this.refreshTrackLayer();
      },
      deep: true
    },
    'isTrackOn.value'() {
      this.refreshTrackLayer();
    },
    'isAnimationOn.value'() {
      this.refreshTrackLayer();
    }
  },
  computed: {
    ...mapState(['stateResult', 'stateIsHeatmap', 'stateIsIDW', 'stateVs']),
    ...mapGetters(['paramTitles']),
    trackPoints() {
      return this.$store.getters.stateTrackPoints;
    }
  },
  created() {
    this.setupWatchers();
  },
  beforeUnmount() {
    this.cleanup();
  },
  methods: {
    setupWatchers() {
      this.unwatchers = [
        this.$store.watch(
          (_, getters) => getters.stateIsHeatmap,
          this.toggleHeatmap
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsIDW,
          this.toggleIDW
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsDrawing,
          this.addIDWLayer
        ),
        this.$store.watch(
          (_, getters) => getters.stateIdwOpacity,
          this.changeIdwOpacity
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsFit,
          this.toggleFit
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsLoadingData,
          this.loadData
        ),
        this.$store.watch(
          (_, getters) => getters.stateIsServerSideCalc,
          this.toggleServerSideCalc
        )
      ];
    },

    refreshTrackLayer() {
      
      // Удаляем старый слой, если есть
      if (this.trackLayer) {
        this.map.removeLayer(this.trackLayer);
        this.trackLayer = null;
      }

      // Отменяем предыдущую анимацию
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }

      // Если трек выключен или нет точек – выходим (обращаемся к .value)
      if (!this.isTrackOn || !this.trackPoints || this.trackPoints.length < 2) return;

      // Создаём линию из точек
      const lineCoords = this.trackPoints.map(p => fromLonLat([p.lon, p.lat]));
      const lineFeature = new Feature({
        geometry: new LineString(lineCoords)
      });

      const source = new VectorSource({
        features: [lineFeature]
      });

      // Создаём стиль в зависимости от анимации
      let lineStyle;
      if (this.isAnimationOn) {
        lineStyle = new Style({
          stroke: new Stroke({
            color: '#3388ff',
            width: 3,
            lineDash: [10, 10],
            lineDashOffset: 0
          })
        });
      } else {
        lineStyle = new Style({
          stroke: new Stroke({
            color: '#3388ff',
            width: 3
          })
        });
      }

      // Создаём слой (теперь до запуска анимации)
      this.trackLayer = new VectorLayer({
        source,
        zIndex: 4,
        style: lineStyle
      });

      this.map.addLayer(this.trackLayer);

      // Если анимация включена, запускаем её
      if (this.isAnimationOn) {
        let dashOffset = 0;
        const animate = () => {
          if (!this.trackLayer) return; // защита от удаления слоя во время анимации
          dashOffset -= 1;
          const resolution = this.map.getView().getResolution();
          const scale = resolution / 10;
          const stroke = this.trackLayer.getStyle().getStroke();
          stroke.setLineDash([10 / scale, 10 / scale]);
          stroke.setLineDashOffset(dashOffset);
          this.trackLayer.changed();
          this.animationFrameId = requestAnimationFrame(animate);
        };
        animate();
      }

      // Подогнать вид под трек
      const extent = source.getExtent();
      this.map.getView().fit(extent, { duration: 1000, padding: [50,50,50,50], maxZoom: 14 });
    },
    createFeatures(source, data, result, isHeatmap = false) {
      // Для heatmap используем объединенные данные из всех активных каналов
      if (isHeatmap) {
        const features = [];
        this.stat.r.coordinates = [[12.431796574819401, 45.42140500309597], [12.43800316632654, 45.40811525714289], [12.43107344066048, 45.39604836738903]]
        this.stat.r.values = [1, 1, 1]
        this.stat.r.times = ['2025-10-08T11:03:20+00:00', '2025-10-08T11:36:40+00:00', '2025-10-08T11:43:20+00:00']
        // Добавляем точки из красного канала
        if (this.$store.getters.stateIsR && this.stat.r && this.stat.r.values && this.stat.r.coordinates) {
          this.stat.r.values.forEach((value, index) => {
            if (this.stat.r.coordinates && this.stat.r.coordinates[index]) {
              const [lon, lat] = this.stat.r.coordinates[index];
              const point = new Point(fromLonLat([lon, lat]));
              const f = new Feature(point);
              f.set('val', Number(value));
              features.push(f);
            }
          });
        }
        
        console.log(`Created ${features.length} heatmap features from stat`);
        features.forEach(f => source.addFeature(f));
        return;
      }
    },

    loadData(isLoading) {
      if (isLoading) {
        if(this.heatmapSource)
          this.heatmapSource.clear();
        if(this.redSource)
          this.redSource.clear();
        if(this.greenSource)
          this.greenSource.clear();
        if(this.blueSource)
          this.blueSource.clear();
      }

    },

    adjustViewToFeatures(source) {
      if (source.getFeatures().length === 0) return;
      const extent = source.getExtent();
      this.new_view.fit(extent, {
        size: this.map.getSize(),
        padding: [50, 50, 50, 50]
      });
    },

    addHeatmapLayer(isHeatmap) {
      if (this.heatmap) {
        // Очищаем существующие данные
        this.heatmapSource.clear();
        
        // Создаем новые features из обновленного stat
        this.createFeatures(this.heatmapSource, this.result.data, 'cdom', true);
        
        this.heatmap.setRadius(this.$store.getters.stateHmPointSize);
        this.heatmap.changed();
        this.heatmap.setVisible(isHeatmap);
      } else {
        this.heatmapSource.clear();
        this.createFeatures(this.heatmapSource, this.result.data, 'cdom', true);
        this.heatmap = new Heatmap({
          visible: isHeatmap,
          source: this.heatmapSource,
          blur: 1,
          radius: this.$store.getters.stateHmPointSize,
          zIndex: 3,
        });
        this.map.addLayer(this.heatmap);
        this.toggleFit(this.$store.getters.stateIsFit);
      }
    },

    toggleFit(isFit) {
      if (isFit)
        this.adjustViewToFeatures(this.heatmapSource);
    },

    toggleHeatmap(isHeatmap) {
      if(this.heatmapSource.getFeatures().length != 0) {
        this.heatmap.setRadius(this.$store.getters.stateHmPointSize);
        this.heatmap.setVisible(isHeatmap);
      }
      else {
        this.addHeatmapLayer(isHeatmap)
      }
    },

    toggleBathmetry(isBathmetry) {
      if(this.bathmetry_layer) {
        this.bathmetry_layer.setVisible(isBathmetry);
      }
      else {
        if(isBathmetry) {
          // GEBCO WMS Layer
          this.bathmetry_layer = new TileLayer({
              source: new TileWMS({
                  url: 'https://wms.gebco.net/mapserv?',
                  params: {
                      'LAYERS': 'GEBCO_LATEST', //GEBCO_LATEST_2',  // GEBCO layer name
                      'VERSION': '1.3.0',       // WMS version
                      'CRS': 'EPSG:3857',        // Use Web Mercator (matches OSM)
                      'FORMAT': 'image/png',
                      'TRANSPARENT': 'true'      // Enable transparency
                  },
                  serverType: 'mapserver',       // Required for MapServer WMS
                  crossOrigin: 'anonymous'
              }),
              opacity: 0.7,  // Adjust opacity to see the base layer
              zIndex: 1
          });
          this.map.addLayer(this.bathmetry_layer);
        }
      }
    },

    changeIdwOpacity(value) {
      if(this.idw_layer)
        this.idw_layer.setOpacity(parseFloat(value));
    },
    toggleServerSideCalc() {

      if (this.idwSource)
        this.idwSource.un('taskstatus', this.handleTask);
        this.idwSource.un('points', this.handlePoints);
        this.idwSource = null;

      // Cleanup vector source
      if (this.redSource) {
        this.redSource.clear();
        this.redSource.dispose();
        this.redSource = new VectorSource();
      }

      // Cleanup vector source
      if (this.greenSource) {
        this.greenSource.clear();
        this.greenSource.dispose();
        this.greenSource = new VectorSource();
      }

      // Cleanup vector source
      if (this.blueSource) {
        this.blueSource.clear();
        this.blueSource.dispose();
        this.blueSource = new VectorSource();
      }
      if(this.idw_layer) {
        this.idw_layer.setMap(null);
        this.idw_layer.dispose && this.idw_layer.dispose();
        this.idw_layer = null;
      }
      
    },

    setOnUn() {
      if(this.$store.getters.stateIsServerSideCalc) {
        this.map.getView().on('change:center', this.doNothing);
        this.map.getView().on('change:resolution', this.doNothing);
        this.map.on('change:size', this.doNothing);
      }
      else {
        this.map.getView().un('change:center', this.doNothing);
        this.map.getView().un('change:resolution', this.doNothing);
        this.map.un('change:size', this.doNothing);
      }

    },

    addIDWLayer(isDrawing) {
      this.map.getInteractions().forEach((i) => {i.setActive(this.isLive);});
      this.enableZoomButtons(this.isLive);
      const useServerSideCalc = this.$store.getters.stateIsServerSideCalc;
      const maxD = this.$store.getters.stateMaxD ? this.$store.getters.stateMaxD : 10;
      const scale = this.$store.getters.stateScale ? this.$store.getters.stateScale : 10;
      const redScale = this.$store.getters.stateIsLog ? 'log' : 'linear';
      const greenScale = this.$store.getters.stateIsLog ? 'log' : 'linear';
      const blueScale = this.$store.getters.stateIsLog ? 'log' : 'linear';
      const redRange = this.getColorRange('red');
      const greenRange = this.getColorRange('green');
      const blueRange = this.getColorRange('blue');
      const redFilter = this.$store.getters.stateIsRFilter ? { min : this.$store.getters.stateRFilterMin, max : this.$store.getters.stateRFilterMax} : {};
      const greenFilter = this.$store.getters.stateIsGFilter ? { min : this.$store.getters.stateGFilterMin, max : this.$store.getters.stateGFilterMax} : {};
      const blueFilter = this.$store.getters.stateIsBFilter ? { min : this.$store.getters.stateBFilterMin, max : this.$store.getters.stateBFilterMax} : {};
      const redPalette = {
        base_color: this.redPaletteConfig.baseColor,
        num_colors: this.redPaletteConfig.numColors,
        use_palette: !this.$store.getters.stateIsG && !this.$store.getters.stateIsB
      };
      
      const greenPalette = {
        base_color: this.greenPaletteConfig.baseColor,
        num_colors: this.greenPaletteConfig.numColors,
        use_palette: !this.$store.getters.stateIsR && !this.$store.getters.stateIsB
      };
      
      const bluePalette = {
        base_color: this.bluePaletteConfig.baseColor,
        num_colors: this.bluePaletteConfig.numColors,
        use_palette: !this.$store.getters.stateIsG && !this.$store.getters.stateIsR
      };
      const start = this.$store.getters.stateIsCustomData ? this.$store.getters.stateDateStart : this.$store.getters.stateCompleteDateStart;
      const end = this.$store.getters.stateIsCustomData ? this.$store.getters.stateDateEnd : this.$store.getters.stateCompleteDateEnd;
      const avg = this.$store.getters.stateAvgTime ? this.$store.getters.stateAvgTime : 0;
      const is_water_mask = this.$store.getters.stateIsWaterMask;
      const is_live = this.isLive;
      const interval_time = this.$store.getters.stateIntervalTime;
      if(is_live) {
        if (this.heatmapSource) {
          this.heatmapSource.clear();
        }
        this.stat.r = { values: [], coordinates: [], times: [] };
        this.stat.g = { values: [], coordinates: [], times: [] };
        this.stat.b = { values: [], coordinates: [], times: [] };
      }
      
      if (this.idw_layer && isDrawing) {
        this.idwSource.setScale('red', redScale);
        this.idwSource.setScale('green', greenScale);
        this.idwSource.setScale('blue', blueScale);
        this.idwSource.setMaxD(maxD);
        this.idwSource.setRanges(redRange, greenRange, blueRange);
        this.idwSource.setFilters(redFilter, greenFilter, blueFilter);
        this.idwSource.setPaletteConfig('red', redPalette);
        this.idwSource.setPaletteConfig('green', greenPalette);
        this.idwSource.setPaletteConfig('blue', bluePalette);
        this.idwSource.setIsServerSideCalc(useServerSideCalc);
        this.idwSource.setScaleGlobal(scale);
        this.idwSource.setSources(this.$store.getters.stateIsR ? this.redSource : new VectorSource(),
                                  this.$store.getters.stateIsG ? this.greenSource : new VectorSource(),
                                  this.$store.getters.stateIsB ? this.blueSource : new VectorSource());
        this.idwSource.setTimeRange(start, end);
        this.idwSource.setAvgTime(avg);
        this.idwSource.setIntervalTime(interval_time);
        this.idwSource.setIsColor(this.$store.getters.stateIsR, this.$store.getters.stateIsG, this.$store.getters.stateIsB);
        this.idwSource.setIsWaterMask(is_water_mask);
        this.idwSource.setIsLive(is_live);
        this.idwSource.setFormulaes(this.formulae_result1, this.formulae_result2, this.formulae_result3);
        if (useServerSideCalc) {
          this.updateIDWLayer();
          this.idwSource.set('changed', false);
          return;
        }
        else
          this.idwSource.setChanged(true);
      }
      else {
        // Verify features have non-zero 'val' values
        this.idwSource = new ol_source_IDW({
          useWorker: false,
          is_cdom: this.$store.getters.stateIsR,
          is_chla: this.$store.getters.stateIsG,
          is_tss: this.$store.getters.stateIsB,
          redSource: this.redSource,
          greenSource: this.greenSource,
          blueSource: this.blueSource,
          weight: 'val',
          scale: scale,
          maxD: maxD,
          projection: 'EPSG:3857', // Explicitly set projection
          redScale: redScale, //'log',      // Logarithmic for red
          greenScale: greenScale,  // Linear (default)
          blueScale: blueScale, //v => Math.sqrt(v) * 2.5  // Custom sqrt scaling
          redRange: redRange,
          greenRange: greenRange,
          blueRange: blueRange,
          redFilter: redFilter,
          greenFilter: greenFilter,
          blueFilter: blueFilter,
          redPalette: redPalette,
          greenPalette: greenPalette,
          bluePalette: bluePalette,
          red_formula: this.formulae_result1,
          green_formula: this.formulae_result2,
          blue_formula: this.formulae_result3,
          useServerSideCalc: useServerSideCalc,
          start_time: start,
          end_time: end,
          avg_time: avg,
          interval: interval_time,
          r_filter: {'min' : this.$store.getters.stateRFilterMin, 'max' : this.$store.getters.stateRFilterMax},
          g_filter: {'min' : this.$store.getters.stateGFilterMin, 'max' : this.$store.getters.stateGFilterMax},
          b_filter: {'min' : this.$store.getters.stateBFilterMin, 'max' : this.$store.getters.stateBFilterMax},
          isWaterMask: is_water_mask,
          isLive: is_live,
          calibrationIdR: this.selectedCalRId || null,
          calibrationIdG: this.selectedCalGId || null,
          calibrationIdB: this.selectedCalBId || null,

        });
        this.idw_layer = new Image({
          visible: this.$store.getters.stateIsIDW,
          title: 'IDW',
          source: this.idwSource,
          opacity: parseFloat(this.$store.getters.stateIdwOpacity),
          zIndex: 2
        });
        this.map.addLayer(this.idw_layer);
        // НОВОЕ: Обработка информации о палитрах от источника IDW
        this.idwSource.on('paletteinfo', (event) => {
          this.$emit('paletteChange', event.paletteInfo );
        });
        this.idwSource.on('taskstatus', this.handleTask);
        this.idwSource.on('points', this.handlePoints);
      }
    },

    async stopIDW() {
      try {
        // Сначала сбросьте UI состояния
        this.isDrawing = false;
        this.isStarted = false;
        this.idwText = "Apply";
        
        if (this.idwSource) {
          await this.idwSource._cancelInterpolation();
        }
        
        // Убедитесь, что событие отправлено даже если idwSource недоступен
        this.$emit('statusDrawing', "taskcancelled", 0);
        
      } catch (error) {
        console.error('Error in stopIDW:', error);
        // Все равно уведомляем об отмене
        this.$emit('statusDrawing', "taskcancelled", 0);
      }
    },

    doNothing() {
      if(this.idwSource) {
        if(this.isLive) 
          this.idwSource.setUpdateParams(true);
        this.idwSource.setChanged(true);
      }
    },
    handleTask (event) {
      if (event.status === 'taskcompleted') {
        console.log('Task completed:', event.taskId);
        this.map.getInteractions().forEach((i) => {i.setActive(true);});
        this.enableZoomButtons(true);
        // this.idwSource.setUpdateParams(false);
        // this.idwSource.setChanged(true);
      }
      else if (event.status === 'taskstarted')
        console.log('Task started:', event.taskId);
      else if (event.status === 'taskcancelled') {
        console.log('Task cancelled:', event.taskId);
        this.map.getInteractions().forEach((i) => {i.setActive(true);});
        this.enableZoomButtons(true);
        // this.idwSource.setUpdateParams(false);
        // this.idwSource.setChanged(true);
      }
      this.$emit('statusDrawing', event.status, event.progress);
    },
    enableZoomButtons(isEnabled) {
      const zoomInBtn = document.querySelector('.ol-zoom .ol-zoom-in');
      const zoomOutBtn = document.querySelector('.ol-zoom .ol-zoom-out');
      [zoomInBtn, zoomOutBtn].forEach(btn => {
        if (btn) {
          btn.style.opacity = isEnabled ? '' : '0.5';
          btn.style.pointerEvents = isEnabled ? '' : 'none';
          if (!isEnabled)
            btn.onclick = null; // Remove OL's click handler
        }
      });
    },
    handlePoints(event) {
      if (event.status === 'points_updated') {
        const interval = this.$store.getters.stateIntervalTime;

        // Преобразуем данные в правильный формат для stat
        const newData = event.data;
        // Создаем новые структуры для stat
        const rData = {
          values: [],
          coordinates: [],
          times: [] // если время не приходит, можно использовать текущее время или оставить пустым
        };
        
        const gData = {
          values: [],
          coordinates: [],
          times: []
        };
        
        const bData = {
          values: [],
          coordinates: [],
          times: []
        };
        console.log("this.$store.getters.stateIntervalTime:", this.$store.getters.stateIntervalTime)
        if(interval != 0) {
          this.stat.r = { values: [], coordinates: [], times: [] };
          this.stat.g = { values: [], coordinates: [], times: [] };
          this.stat.b = { values: [], coordinates: [], times: [] };
        }
        

        // Обрабатываем каждый массив данных
        newData.data.forEach(point => {
          if (point && point.length >= 5) {
            const [lat, lon, rValue, gValue, bValue] = point;
            
            // Добавляем данные для красного канала
            if (this.$store.getters.stateIsR && rValue !== 0) {
              this.stat.r.values.push(rValue);
              this.stat.r.coordinates.push([lon, lat]);
              this.stat.r.times.push(new Date().toISOString()); // или другое время, если доступно
            }
            
            // Добавляем данные для зеленого канала
            if (this.$store.getters.stateIsG && gValue !== 0) {
              this.stat.g.values.push(gValue);
              this.stat.g.coordinates.push([lon, lat]);
              this.stat.g.times.push(new Date().toISOString());
            }
            
            // Добавляем данные для синего канала
            if (this.$store.getters.stateIsB && bValue !== 0) {
              this.stat.b.values.push(bValue);
              this.stat.b.coordinates.push([lon, lat]);
              this.stat.b.times.push(new Date().toISOString());
            }
          }
        });
        // if(interval != 0) {
        //   // Обновляем stat
        //   this.stat.r = rData;
        //   this.stat.g = gData;
        //   this.stat.b = bData;
        // }
        // else
        // {
        //   this.stat.r.push(...rData);
        //   this.stat.g.push(...gData);
        //   this.stat.b.push(...bData);
        // }

        

        console.log('Updated stat:', {
          r: { count: rData.values.length, sample: rData.values.slice(0, 3) },
          g: { count: gData.values.length, sample: gData.values.slice(0, 3) },
          b: { count: bData.values.length, sample: bData.values.slice(0, 3) }
        });

        // Обновляем heatmap
        this.addHeatmapLayer(this.$store.getters.stateIsHeatmap);
      }
    },
    async updateIDWLayer(isUpdateParams) {
      if(this.idwSource) {
        await this.idwSource.updateCanvas(isUpdateParams);
      }
    },
    getColorRange(color) {
      if(color == "red") {
        if (!this.$store.getters.stateIsRRange)
          return null
        const red_min = this.$store.getters.stateIsRRange ? this.$store.getters.stateRMin : null
        const red_max = this.$store.getters.stateIsRRange ? this.$store.getters.stateRMax : null
        return [this.$store.getters.stateIsLog ? Math.log10(1 + red_min) : red_min,
                this.$store.getters.stateIsLog ? Math.log10(1 + red_max) : red_max]
      }
      else if (color == "green") {
        if (!this.$store.getters.stateIsGRange)
          return null
        const green_min = this.$store.getters.stateIsGRange ? this.$store.getters.stateGMin : null
        const green_max = this.$store.getters.stateIsGRange ? this.$store.getters.stateGMax : null
        return [this.$store.getters.stateIsLog ? Math.log10(1 + green_min) : green_min,
                this.$store.getters.stateIsLog ? Math.log10(1 + green_max) : green_max]
      }
      else if (color == "blue") {
        if (!this.$store.getters.stateIsBRange)
          return null
        const blue_min = this.$store.getters.stateIsBRange ? this.$store.getters.stateBMin : null
        const blue_max = this.$store.getters.stateIsBRange ? this.$store.getters.stateBMax : null
        return [this.$store.getters.stateIsLog ? Math.log10(1 + blue_min) : blue_min,
                this.$store.getters.stateIsLog ? Math.log10(1 + blue_max) : blue_max]
      }
    },

    toggleIDW(isIDW) {
      if(this.idw_layer)
      {
        this.idw_layer.setVisible(isIDW);
      }
      // this.setDrawingState(false)
    },
    setupPopup() {
      const overlay = new Overlay({
        element: this.$refs.popup,
        autoPan: { animation: { duration: 250 } }
      });

      this.$refs.popupCloser.onclick = () => {
        overlay.setPosition(undefined);
        return false;
      };

      this.clickListenerKey = this.map.on('singleclick', evt => {
        try {
          this.isClicked = false;
          const coordinate = evt.coordinate;
          const [lon, lat] = toLonLat(coordinate);
          const near_point_data = this.findNearestPoint(lon, lat);
          this.sel_coords = near_point_data.coordinates;
          this.sel_time = new Date(near_point_data.properties.time).toUTCString();
        
          if(near_point_data.coordinates) {

            overlay.setPosition(fromLonLat(near_point_data.coordinates));

            this.$refs.popupContent.innerHTML = `
              <table>
                <tr><th>Coordinates:</th><td>${near_point_data.coordinates[1].toFixed(4)}, ${near_point_data.coordinates[0].toFixed(4)}</td></tr>
                <tr><th>Datetime:</th><td>${near_point_data.properties.time ? new Date(near_point_data.properties.time).toUTCString() : 'N/A'}</td></tr>
              </table>
            `;
            if (this.stat && this.stat.r && this.stat.r.values && this.stat.r.values.length > 0) {
              console.log("this.showFluoPanel = true;")
              this.showFluoPanel = true;
            } else {
              this.showFluoPanel = false;
            }
          }
        }
        catch (error) {
          console.error(error)
        }
      });

      this.map.addOverlay(overlay);
      this.overlay = overlay;
    },

    findNearestPoint(longitude, latitude) {
      function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371e3;
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lon2 - lon1) * Math.PI / 180;

        const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
                  Math.cos(φ1) * Math.cos(φ2) *
                  Math.sin(Δλ/2) * Math.sin(Δλ/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

        return R * c;
      }

      let nearestPoint = null;
      let minDistance = Infinity;

      // Используем обычный объект вместо Map
      const pointsMap = {};

      // Функция для добавления точек в объект
      const addPointsToMap = (channel, values, coordinates, times, resultKey) => {
        if (values && coordinates) {
          values.forEach((value, index) => {
            if (coordinates[index]) {
              const [lon, lat] = coordinates[index];
              const coordKey = `${lon.toFixed(6)},${lat.toFixed(6)}`; // ключ для группировки по координатам
              
              if (!pointsMap[coordKey]) {
                pointsMap[coordKey] = {
                  coordinates: [lon, lat],
                  properties: {
                    time: times ? times[index] : 'N/A',
                    result1: null,
                    result2: null,
                    result3: null
                  }
                };
              }
              
              // Добавляем значение в соответствующее свойство
              const point = pointsMap[coordKey];
              point.properties[resultKey] = value;
            }
          });
        }
      };

      // Добавляем точки из всех каналов
      if (this.$store.getters.stateIsR && this.stat.r && this.stat.r.values) {
        addPointsToMap('r', this.stat.r.values, this.stat.r.coordinates, this.stat.r.times, 'result1');
      }
      
      if (this.$store.getters.stateIsG && this.stat.g && this.stat.g.values) {
        addPointsToMap('g', this.stat.g.values, this.stat.g.coordinates, this.stat.g.times, 'result2');
      }
      
      if (this.$store.getters.stateIsB && this.stat.b && this.stat.b.values) {
        addPointsToMap('b', this.stat.b.values, this.stat.b.coordinates, this.stat.b.times, 'result3');
      }

      // Ищем ближайшую точку среди всех сгруппированных точек
      Object.keys(pointsMap).forEach(coordKey => {
        const point = pointsMap[coordKey];
        const [lon, lat] = point.coordinates;
        const distance = calculateDistance(latitude, longitude, lat, lon);
        
        if (distance < minDistance) {
          minDistance = distance;
          nearestPoint = {
            ...point,
            distance: distance
          };
        }
      });

      return nearestPoint;
    },
    async cancelDrawing() {
      // Защита от множественных нажатий
      if (this.isCancelling) return;
      
      this.isCancelling = true;
      try {
        this.idwAction = 'cancel';
        this.isDrawing = false;
        this.isStarted = false;
        this.idwText = "Apply";
        
        // Принудительно отправьте событие отмены
        this.$emit('statusDrawing', "taskcancelled", 0);
      } finally {
        // Сбросьте флаг отмены через небольшую задержку
        setTimeout(() => {
          this.isCancelling = false;
        }, 1000);
      }
    },

    cleanup() {
      this.stopIDW();
      // Cleanup event listeners
      if (this.clickListenerKey) {
        unByKey(this.clickListenerKey);
        this.clickListenerKey = null;
      }

      // Cleanup store watchers
      this.unwatchers.forEach(unwatch => unwatch());
      this.unwatchers = [];

      // Properly dispose layers
      [this.heatmap, this.idw_layer].forEach(layer => {
        if (layer) {
          layer.setMap(null);
          layer.dispose && layer.dispose();
        }
      });

      if (this.idwSource) {
        this.idwSource.un('taskstatus', this.handleTask);
        this.idwSource.un('points', this.handlePoints);
        this.idwSource.un('paletteinfo', this.handlePoints);
        this.idwSource = null;
        this.idwSource.stopStreaming();
        this.map.getView().un('change', this.updateStreamingParameters);

      }

      // Cleanup vector source
      if (this.redSource) {
        this.redSource.clear();
        this.redSource.dispose();
        this.redSource = null;
      }

      // Cleanup vector source
      if (this.greenSource) {
        this.greenSource.clear();
        this.greenSource.dispose();
        this.greenSource = null;
      }

      // Cleanup vector source
      if (this.blueSource) {
        this.blueSource.clear();
        this.blueSource.dispose();
        this.blueSource = null;
      }

      // Cleanup vector source
      if (this.heatmapSource) {
        this.heatmapSource.clear();
        this.heatmapSource.dispose();
        this.heatmapSource = null;
      }

      // Cleanup map
      if (this.map) {
        this.map.getOverlays().forEach(overlay => overlay.dispose());
        this.map.setTarget(null);
        this.map.dispose();
        this.map = null;
      }

      // Cleanup view
      if (this.new_view) {
        this.new_view.dispose();
        this.new_view = null;
      }

      // Cleanup DOM references
      if (this.$refs.popup) {
        this.$refs.popup.innerHTML = '';
      }
      // Remove entire map container from DOM
      if (this.$refs['map-root']) {
        this.$refs['map-root'].innerHTML = '';
        this.$refs['map-root'].remove();
      }

      if (this.trackLayer && this.map) {
        this.map.removeLayer(this.trackLayer);
        this.trackLayer = null;
      }

      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      this.showFluoPanel = false;
    }
  },
  mounted() {
    let layer;

    if (process.env.VUE_APP_MAP_SOURCE === 'local') {
      // Local TileServer-GL
      layer = new TileLayer({
        source: new XYZ({
          url: '/tiles/{z}/{x}/{y}.png',  // Proxy path
        }),
        zIndex: 0
      });
    } else {
      // Default OSM
      layer = new TileLayer({
        source: new OSM(),
        zIndex: 0
      });
    }
    this.map = new Map({
      target: this.$refs['map-root'],
      layers: [
        layer
      ],
      view: this.new_view,
      controls: defaultControls({
        attributionOptions: {
          collapsible: false // Keep attribution always visible
        }
      }).extend([
        new ScaleLine({
          units: 'metric' // or 'imperial'
        })
      ])
    });
  
    this.setupPopup();
    this.setOnUn();
  }
};
</script>

<style scoped>
.bottom-panel {
  height: 30%;
  width: 100%;
  display: flex;
  flex-direction: row;
  border-top: 1px solid #ccc;
  background: #f8f9fa;
}

/* Левая фиксированная панель (пустая) */
.panel-left-fixed {
  width: 300px;
  flex-shrink: 0;
  background-color: #e9ecef; /* временный фон для визуализации */
  border-right: 1px solid #ddd;
}

/* Контейнер для графика и правой панели */
.panel-content {
  flex: 1;
  display: flex;
  flex-direction: row;
}

/* Область графика (занимает 80% от panel-content) */
.panel-chart {
  flex: 4; /* 4 части из 5 (80%) */
  padding: 4px;
}

/* Правая панель (занимает 20% от panel-content) */
.panel-right {
  flex: 1;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  padding: 8px; /* отступы по вашему усмотрению */
  border-left: 1px solid #ddd;
  background-color: #fff; /* или любой другой фон */
}
/* Остальные стили (ol-popup, .ol-zoom и т.д.) остаются без изменений */
.ol-scale-line {
  position: absolute;
  left: calc(100% - 183px);
  bottom: 20px;
  background: rgba(255,255,255,0.7);
  padding: 2px;
}
.ol-zoom {
  top: 8px !important;
  left: auto !important;
  right: 8px !important;
  bottom: auto !important;
}
.ol-zoom .ol-zoom-in {
  border-radius: 4px 4px 0 0 !important;
}
.ol-zoom .ol-zoom-out {
  border-radius: 0 0 4px 4px !important;
}
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 340px;
}
.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: "✖";
}
</style>